import React, { useState } from 'react';

import { MenuItem, Select, FormControl } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { TEAM_TYPE } from 'constants/ProjectConstants';
import { generateKey, getRandomInt } from 'constants/helper';

import TeamTypeIcon from './TeamTypeIcon';
import TeamVisibilityIcon from './TeamVisibilityIcon';

// Don't use this anymore, this is not a modular way to use
// Use CustomMenu component
export default function MeshDropdown({
  menuId,
  menuItems,
  selected,
  onChange,
  cssStyles,
  fullWidth = false,
  valueKey = 'value',
  displayKey = 'name',
  className,
  margin = 'dense',
  displayVisibilityTypeIcon = false,
  displayTeamTypeIcon = false,
  isDisabled = false,
  placeholderMenuItem,
  startAdornment,
  endAdornment,
  IconComponent = ArrowDropDownIcon,
  noBorder = false,
}) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  function handleChange(e) {
    onChange(e.target.value);
  }

  return (
    <FormControl
      className={className}
      variant={noBorder ? 'standard' : 'outlined'}
      margin={margin}
      fullWidth={fullWidth}
    >
      <StyledSelect
        {...(noBorder && { disableUnderline: true })}
        disabled={isDisabled}
        onChange={handleChange}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        value={selected}
        cssStyles={cssStyles}
        displayEmpty
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        IconComponent={IconComponent}
        // disablePortal will force select dropdown to be a child node of clickAwayListener,
        // this will prevent clickawaylistener to be triggered on click of select dropdown or menuItem
        MenuProps={{ disablePortal: true }}
        inputProps={{
          name: menuId || `meshDropdown${generateKey(7)}`,
        }} // adding name makes the idea of the menu that opens = menu-${name}
      >
        {placeholderMenuItem}
        {menuItems.map((item, i) => (
          <StyledMenuItem
            value={item[valueKey]}
            key={`${menuId}-item-${i}`}
            padded={displayVisibilityTypeIcon || displayTeamTypeIcon}
            separator={item.teamType === TEAM_TYPE.personal || item.id === -4 || item.id === -5}
            italics={item.teamType === TEAM_TYPE.personal}
            isDisabled={item.isisDisabled}
          >
            {item[displayKey]}
            {open && <TeamTypeIcon show={displayTeamTypeIcon} teamType={item.teamType} />}
            {open && <TeamVisibilityIcon show={displayVisibilityTypeIcon} visibilityType={item.visibilityType} />}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}

const DrodownContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledSelect = styled(Select)`
  ${(props) => props.cssStyles && props.cssStyles};
  // span {
  //   opacity: 0;
  // }
`;

export const StyledMenuItem = styled(MenuItem)`
  ${(props) =>
    props.padded &&
    css`
      padding-right: 70px;
    `};
  ${(props) =>
    props.separator &&
    css`
      border-top: 1px solid #f1f1f1;
    `};
  ${(props) =>
    props.italics &&
    css`
      font-style: italic;
    `};
`;

MeshDropdown.defaultProps = {
  menuId: `simpleMenu${getRandomInt()}${getRandomInt()}`,
};

MeshDropdown.propTypes = {
  menuId: PropTypes.string,
  icon: PropTypes.element.isRequired,
  menuItems: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.isRequired,
};
